<template>
    <div class="control-group">
        <div class="control-label">
            <label :id="f_type" :for="f_type + 'f'">
                {{this.f_type}}
            </label>
        </div>
        <div class="controls">
            <div class="simple_text company_name">
                {{this.f_val}}
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "company_info_field",
    props : {
        f_type : {
            type:  String
        },
        f_val : {
            type : String,
            default : '',
        }
    }
}
</script>


<style scoped>

</style>